import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ButtonVariant, useModal } from '@ampol/design-system';
import Header from 'components/header/header';
import UserProfileForm from 'forms/user-profile-form/user-profile-form';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * Header wrapper component
 * @returns JSX Element
 */
const HeaderWrapper = ({ routes, maintenanceActive }) => {
  const updateUserProfileSelfLoading = useSelector((state) => state.userStore.updateUserProfileSelfLoading);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);

  const [updateButtonEnabled, setUpdateButtonEnabled] = useState(false);

  const handleOpenUserProfileModal = () => {
    window.dataLayer.push({
      event: 'Secondary_Nav_Your_Profile_Click',
      click: true,
    });
    trackCustomEvent('Open Your Profile Modal', loggedInUser, undefined, 'Clicked on Your Profile link to view profile details.');
    userProfileModal.open();
  };

  const userProfileModal = useModal({
    id: 'user-profile-modal',
    formId: 'user-profile-form',
    title: 'Your Profile',
    content: <UserProfileForm 
      formId={'user-profile-form'}
      setUpdateButtonEnabled={setUpdateButtonEnabled}
    />,
    variant: 'double',
    actions: [
      {
        label: 'Update',
        type: 'submit',
        inactive: !updateButtonEnabled || updateUserProfileSelfLoading,
      },
      {
        label: 'Cancel',
        onClick: () => userProfileModal.close(),
        variant: ButtonVariant.Secondary,
      },
    ],
    color: 'blue',
    onClose: () => trackCustomEvent('Close Your Profile Modal', loggedInUser, undefined, 'Closed Your Profile modal.'),

  });

  return <>
    <Header
      routes={routes}
      onYourProfileClick={handleOpenUserProfileModal}
      maintenanceActive={maintenanceActive}
    />
  </>;
};

export default HeaderWrapper;
